import { render } from "./PageFooter.vue.js?vue&type=template&id=5eb97f26!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageFooter.vue?vue&type=template&id=5eb97f26"
import script from "./PageFooter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/PageFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5eb97f26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5eb97f26', __exports__)) {
    api.reload('5eb97f26', __exports__)
  }
  
  module.hot.accept("./PageFooter.vue.js?vue&type=template&id=5eb97f26!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageFooter.vue?vue&type=template&id=5eb97f26", () => {
    api.rerender('5eb97f26', render)
  })

}


export default __exports__